import React from 'react';
import { Presentation, GraduationCap, BookOpen, Users, Award, Briefcase } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useTranslation } from 'react-i18next';

const iconMap = {
  Presentation: Presentation,
  GraduationCap: GraduationCap,
  BookOpen: BookOpen,
  Users: Users,
  Award: Award,
  Briefcase: Briefcase
};

const Services = () => {
  const { t } = useTranslation();
  
  const services = [
    { icon: 'Presentation', key: 'lectures' },
    { icon: 'GraduationCap', key: 'training' },
    { icon: 'BookOpen', key: 'courses' },
    { icon: 'Users', key: 'events' },
    { icon: 'Award', key: 'program' },
    { icon: 'Briefcase', key: 'consulting' }
  ];

  return (
    <section 
      id="services" 
      className="py-20 bg-gray-50"
      aria-label="Seção de serviços especializados"
    >
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span 
            className="bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4"
            role="text"
          >
            {t('services.badge')}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div 
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          role="list"
          aria-label="Lista de serviços oferecidos"
        >
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={index}
                className="border border-gray-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
                role="listitem"
              >
                <CardContent className="p-8">
                  <div 
                    className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300"
                    aria-hidden="true"
                  >
                    <IconComponent className="text-white" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {t(`services.items.${service.key}.title`)}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {t(`services.items.${service.key}.description`)}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center" role="complementary">
          <p className="text-gray-600 mb-6">
            {t('services.ctaText')}
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-200"
            aria-label={t('services.ctaButton')}
          >
            {t('services.ctaButton')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
